import { Shield, Lock, Activity } from 'lucide-react';

import { Icon } from '@@/Icon';

import {
  Recommendation,
  RecommendationCategory,
  RECOMMENDATION_CATEGORY,
  CATEGORY_LABELS,
} from './types';
import { RecommendationItem } from './RecommendationItem';

const categoryIcons: Record<RecommendationCategory, typeof Shield> = {
  [RECOMMENDATION_CATEGORY.GOVERNANCE]: Shield,
  [RECOMMENDATION_CATEGORY.SECURITY]: Lock,
  [RECOMMENDATION_CATEGORY.OPERATIONS]: Activity,
};

interface Props {
  category: RecommendationCategory;
  items: Recommendation[];
}

export function CategorySection({ category, items }: Props) {
  if (items.length === 0) {
    return null;
  }

  const CategoryIcon = categoryIcons[category];

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Icon
          icon={CategoryIcon}
          className="text-gray-7 th-highcontrast:text-white th-dark:text-white"
        />
        <h3 className="m-0 text-sm font-semibold text-gray-8 th-highcontrast:text-white th-dark:text-white">
          {CATEGORY_LABELS[category]}
        </h3>
        <span className="text-xs text-gray-6 th-highcontrast:text-white th-dark:text-white">
          ({items.length})
        </span>
      </div>
      <div className="space-y-2">
        {items.map((rec) => (
          <RecommendationItem key={rec.typeId} recommendation={rec} />
        ))}
      </div>
    </div>
  );
}
